import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.min.css';
document.addEventListener('DOMContentLoaded', function(){

let currentFilters = {};
let currentSort = {
  type: null,
  direction: null
};
let brandIdFromUrl = '';
let modelIdFromUrl = '';
const containerParams = document.querySelector('.params'); 
const baseParams = JSON.parse(containerParams.dataset.params);
const filterForm = document.querySelector('.filter-form');


function updateUrl() {
   const urlParams = formDataToUrlParams(filterForm);
   const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
    window.history.pushState({}, '', newUrl);

}


async function loadCars(page = 1) {
    const loader = document.querySelector('.loading');
    if (loader) loader.style.display = 'flex';
  

    try {
        // 1. Создаем объект с данными запроса
        const requestData = {
            ...currentFilters,
            page: page,
          
        };



          // 2. Добавляем параметры сортировки, если они есть
        if (currentSort && currentSort.type) {
            requestData.sort = {
                type: currentSort.type,
                direction: currentSort.direction
            };
        }
        
        // 3. Отправляем запрос
        const response = await fetch('/api/cars/filter', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(requestData) // Используем requestData здесь
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        
        if (data.total == 0) {
         document.getElementById('cars-list').innerHTML =   `
                <div class="alert alert-info">
                  По заданным параметрам ничего не найдено
                </div>
            `;
            document.querySelector('.pagination-container').innerHTML = '';
            return;
        }
      
 document.getElementById('cars-list').innerHTML = data.html;
  document.querySelector('.pagination-container').innerHTML = data.pagination_html;
  
     
          
updateUrl();




    } catch (error) {
        console.error('Error loading cars:', error);
        // Можно добавить отображение ошибки пользователю
    } finally {
        if (loader) loader.style.display = 'none';

    }
}





  function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }

const debouncedLoadCars = debounce(loadCars, 300);

document.querySelector('.filter-form').addEventListener('submit', (e) => {
    e.preventDefault();
  
    const formData = new FormData(e.target);
    currentFilters = Object.fromEntries(formData.entries());
  debouncedLoadCars();
  
});

function clearBaseParams() {
    if (Object.keys(baseParams).length > 0) {
          Object.keys(baseParams).forEach(function(key){
          console.log(baseParams[key]);
            // delete baseParams[key]
    });
}
}

if (Object.keys(baseParams).length > 0) {
    Object.keys(baseParams).forEach(key => {
        const value = baseParams[key];
        
        if (value !== null && value !== undefined && value !== '') {
            console.log(`Устанавливаем ${key} = ${value}`);
            
            if (key == 'brand') {
              brandIdFromUrl = value;
            }
           if (key == 'model') {
                modelIdFromUrl = value;
              
            }
            // Ищем все элементы с данным name (input, select, textarea)
            const elements = document.querySelectorAll(`[name="${key}"]`);
            
            elements.forEach(element => {
                if (element.type === 'checkbox') {
                    // Для чекбоксов
                    element.checked = Boolean(value);
                } else if (element.type === 'radio') {
                    // Для радиокнопок
                    const radio = document.querySelector(`[name="${key}"][value="${value}"]`);
                    if (radio) radio.checked = true;
                } else if (element.tagName === 'SELECT') {
                    // Для select
                    element.value = value;
                } else {
                    // Для input, textarea
                    element.value = value;
                }
            });
        }
    });
      const formData = new FormData(filterForm);
          

    currentFilters = Object.fromEntries(formData.entries());
        if (baseParams.model) {
                let modelId = parseInt(baseParams.model);
               currentFilters.model = modelId;   
               clearBaseParams();
             
            }
  debouncedLoadCars();
}









  
 
const commonConfig = {
  itemSelectText: 'Выбрать',
  searchPlaceholderValue: 'Поиск...',
  noResultsText: 'Не найдено...',
  searchEnabled: false
};
const selectors = [
  { selector: '.f-brand', options: { searchEnabled: true } },
  { selector: '.f-model', options: { searchEnabled: true } },
  { selector: '.f-fuel_type' },
  { selector: '.f-engine_displacement' },
  { selector: '.f-engine_displacementto' },
  { selector: '.f-transmission' },
  { selector: '.f-body_type' },
  { selector: '.f-country' },
  { selector: '.f-drive' },
  { selector: '.f-horsepower' },
  { selector: '.f-horsepowerto' },
  { selector: '.f-year' },
  { selector: '.f-yearto' },
  { selector: '.f-color' },
  // { selector: '.f-price',options: { placeholder: true , placeholderValue: 'Цена, до'} }
];

const choicesInstances = {};


  selectors.forEach(({ selector, options = {} }) => {
    const element = document.querySelector(selector);
    if (element) {
      choicesInstances[selector] = new Choices(element, { 
        ...commonConfig, 
        ...options 
      });
    }
  });


const brandElement = document.querySelector('.f-brand');
    brandElement.addEventListener('change', debounce(async (e) => {
      const brandId = e.detail.value;
    //    choicesInstances['.f-model'].setChoices(
    //   [{ value: '', label: 'Сначала выберите бренд', disabled: true }],
    //   'value',
    //   'label',
    //   true
    // );
  await loadModelsByBrand(brandId);
    }));
  

  // Инициализация пустого списка моделей
  if (choicesInstances['.f-model']) {
    choicesInstances['.f-model'].setChoices(
      [{ value: '', label: 'Сначала выберите бренд', disabled: true }],
      'value',
      'label',
      true
    );
  }


function clearSort() {
    if (filterSort) {
      currentSort = {
  type: null,
  direction: null
};
         const els = filterSort.querySelectorAll('.item');
          els.forEach((ctx) => {
               els.forEach(el => el.classList.remove('active'));
  
  }); 
    }
}



const showFIlter = document.querySelector('.show-filter');
const hiddensFilter = document.querySelectorAll('.f-hidden');


showFIlter.addEventListener('click',()=>{
  const text =  showFIlter.textContent.trim();
     showFIlter.textContent = text.includes('Подробный фильтр') 
        ? text.replace('Подробный фильтр', 'Скрыть') 
        : text.replace('Скрыть', 'Подробный фильтр');
  
  hiddensFilter.forEach((ctx)=>{
      ctx.classList.toggle('active');
  });
})

const resetFilter = document.querySelector('.clear-filter');
resetFilter.addEventListener('click',()=> {

  const inputs = filterForm.querySelectorAll('input');
    inputs.forEach(input=>{
      input.value='';
    });

   Object.values(choicesInstances).forEach(choiceInstance => {
      try {
        // Сбрасываем выбор
        choiceInstance.removeActiveItems();
            document.getElementById('cars-list').innerHTML = '';
            document.querySelector('.pagination-container').innerHTML = '';
          
        // Очищаем поиск (если есть)
        if (choiceInstance.input) {
          choiceInstance.input.value = '';
        }
       
      } catch (error) {
        console.error('Error resetting filter:', error);
      }
    });
    updateUrl();
});




function formDataToUrlParams(formElement) {

  const formData = new FormData(formElement);
   const urlParams = new URLSearchParams();
    const processedKeys = new Set();
    
    for (let [key, value] of formData.entries()) {
        if (processedKeys.has(key)) continue;
        
        if (value !== '' && value !== null && value !== undefined) {
            const allValues = formData.getAll(key);
            
            if (allValues.length > 1) {
                // Множественные значения
                allValues.forEach(val => {
                    urlParams.append(key, val);
                });
            } else {
                // Одиночное значение
                urlParams.append(key, value);
            }
        }
        
        processedKeys.add(key);
    }


    return urlParams;
}
// search form

  

async function loadModelsByBrand(brandId, modelChoicesElement = '.f-model') {
    const modelChoices = choicesInstances[modelChoicesElement];
   
    if (!modelChoices) {
        console.error('Choice instance not found for:', modelChoicesElement);
        return;
    }

    // Сбрасываем текущий выбор
    modelChoices.removeActiveItems();
    
    // Показываем состояние загрузки
    modelChoices.setChoices([{ value: '', label: 'Загрузка...', disabled: true }]);

    try {
        const response = await fetch(`/api/models?brand_id=${brandId}`);
        const models = await response.json();
        
        if (models.data && models.data.length > 0) {
            const choices = [
                { value: '', label: 'Выберите модель', selected: true, disabled: true }
            ].concat(
                models.data.map(model => ({
                    value: model.id,
                    label: model.title
                }))
            );

            modelChoices.setChoices(choices, 'value', 'label', true);
              
               if (baseParams.model) {
                   console.log('starts')
                let modelId = parseInt(baseParams.model);
                modelChoices.setChoiceByValue(modelId);
         
            }
  

        } else {
            modelChoices.setChoices([{ value: '', label: 'Нет моделей для этого бренда', disabled: true }]);
        }
    } catch (error) {
        console.error('Error loading models:', error);
        modelChoices.setChoices([{ value: '', label: 'Ошибка загрузки', disabled: true }]);
    }
}

      if (brandIdFromUrl != '') {
    loadModelsByBrand(brandIdFromUrl);
    
}


const filterSort = document.querySelector('.filter-sort-catalog');

if (filterSort) {
   const els = filterSort.querySelectorAll('.item');
  els.forEach((ctx) => {
    ctx.addEventListener('click', debounce(() => {
      els.forEach(el => el.classList.remove('active'));
      
      const type = ctx.getAttribute('data-type');
      const sort = ctx.getAttribute('data-sort');
      
      ctx.classList.add('active');
      currentSort = { type, direction: sort };
      
      // Инверсия для следующего клика
      ctx.setAttribute('data-sort', sort === 'asc' ? 'desc' : 'asc');
    
   
      
      debouncedLoadCars(1);
    }, 300));
  });
}

 const allSelects = document.querySelectorAll('select');

    allSelects.forEach(select => {
        select.addEventListener('change', function(){

          if (baseParams.model) {
            clearBaseParams();
             const modelChoices = choicesInstances['.f-model'];
             modelChoices.removeActiveItems();
          }



      const filterForm = document.querySelector('.filter-form');
     const formData = new FormData(filterForm);
         

    currentFilters = Object.fromEntries(formData.entries());
      
  debouncedLoadCars();
        });
    });


  document.addEventListener('click', (e) => {
    if (e.target.closest('.page-link')) {
        e.preventDefault();
        const page = e.target.closest('.page-link').dataset.page;
        debouncedLoadCars(page);
    }
});


});